export const FILTER_TYPE = {
    textField: "textField",
    checkbox: "checkbox",
    datePicker: "datePicker",
    rangePicker: "rangePicker",
    dropdownAutocomplete: "dropdownAutocomplete",
    orgDropdownAutocomplete: "orgDropdownAutocomplete",
    peopleDropdownAutocomplete: "peopleDropdownAutocomplete",
    masterDataAutocomplete: "masterDataAutocomplete",
    masterDataMultiAutocomplete: "masterDataMultiAutocomplete",
    matterDropdownAutocomplete: "matterDropdownAutocomplete",
    peopleMultiDropdownAutocomplete: "peopleMultiDropdownAutocomplete",
}
